"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSetupForTests = exports.setupStyledComponents = void 0;

var _BrowserTest = require("../utils/BrowserTest");

var _domReady = require("./domReady");

var SC_ATTR = 'data-hubspot-styled-components'; // Custom for our styled-components repackage

var documentHeadObserver;
var DOCUMENT_HEAD_OBSERVER_OPTIONS = {
  childList: true
};

var reinsertNonStyledComponentsTags = function reinsertNonStyledComponentsTags() {
  documentHeadObserver.disconnect(); // prevent infinite loops

  [document.head, document.body].forEach(function (container) {
    var styleTags = container.querySelectorAll("link[rel=\"stylesheet\"], style:not([" + SC_ATTR + "])");
    [].slice.call(styleTags).forEach(function (styleTag) {
      var originalSheet = styleTag.sheet;

      try {
        // eslint-disable-next-line no-unused-expressions
        originalSheet && originalSheet.rules;
      } catch (e) {
        // Access denied when accessing rules (#6663), ignore this sheet
        return;
      }

      container.appendChild(styleTag);
      var newSheet = styleTag.sheet;
      if (!originalSheet || !originalSheet.rules || !newSheet || !newSheet.rules) return; // #5863
      // Ensure that any styles that were inserted dynamically are carried over.

      if (newSheet.rules.length < originalSheet.rules.length) {
        for (var i = 0; i < originalSheet.rules.length; i++) {
          if (originalSheet.rules[i] !== newSheet.rules[i]) {
            newSheet.insertRule(originalSheet.rules[i].cssText, i);
          }
        }
      }
    });
  });
  documentHeadObserver.observe(document.head, DOCUMENT_HEAD_OBSERVER_OPTIONS);
};

var hasSetupStyledComponents = false;

var oneTimeSetupStyledComponents = function oneTimeSetupStyledComponents() {
  if (hasSetupStyledComponents) return;
  var head = document.head; // Cleanup for the styled-components v3/v4 repackage logic, no longer needed for v5

  var anchorTag = head.querySelector('[data-hubspot-styled-components-anchor]');

  if (anchorTag != null) {
    head.removeChild(anchorTag);
  }

  if ((0, _BrowserTest.ignoresStyleTagInsertionOrder)()) {
    // IE11 and Edge < 17 base style precedence on when tags were inserted, rather than their order
    // in the DOM! So, to keep the ordering consistent, we need to re-insert all style tags that are
    // *not* from styled-components any time a styled-components tag is added.
    documentHeadObserver = new MutationObserver(reinsertNonStyledComponentsTags);
    documentHeadObserver.observe(document.head, DOCUMENT_HEAD_OBSERVER_OPTIONS);
    reinsertNonStyledComponentsTags();
  }

  hasSetupStyledComponents = true;
  return;
};

var setupStyledComponents = function setupStyledComponents() {
  (0, _domReady.domReady)(function () {
    setTimeout(oneTimeSetupStyledComponents, 0); // Ensure that this method runs in its own tick
  });
};

exports.setupStyledComponents = setupStyledComponents;

var resetSetupForTests = function resetSetupForTests() {
  hasSetupStyledComponents = false;
};

exports.resetSetupForTests = resetSetupForTests;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/listeners/setupStyledComponents.js
// module id = 224
// module chunks = 5 6 7